import script from "./CaptchaSmsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaSmsDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__